var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeMobile1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 193 152",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M152.056 14.005C123.943 -6.44557 83.6309 -2.44625 49.1349 18.0924C29.9699 29.5031 0.256302 52.0691 0.208293 85.3521C0.0576071 189.824 170.607 152.801 190.032 95.226C197.292 73.7074 188.832 40.7579 152.056 14.005Z",
  fill: "current"
})));
export default SvgShapeMobile1;